import styled from 'styled-components';

import PropTypes from 'prop-types';

const Divider = styled.div`
  height: ${props => props.height}px;
`;

Divider.defaultProps = {
  height: 10
}

Divider.propTypes = {
  height: PropTypes.number
}


export default Divider;